module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Pagination 分页器")]), _vm._v(" "), _c('pagination', {
    attrs: {
      "total": 120,
      "next": _vm.go,
      "show-total": true
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div>\n  <!--全局引入后的用法-->\n  <pagination :total=\"120\" :next=\"go\" :show-total=\"true\"></pagination>\n</div>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("pn")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("当前页(默认第1页)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("total")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("总共数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("size")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("分页大小(每页多少条数据)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("next")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("Function")]), _vm._v(" "), _c('td', [_vm._v("选择页面之后的回调")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-total")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("是否显示总页数")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261c721c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/pagination-demo.vue
// module id = 387
// module chunks = 1